import './GreenEditableSection.css';

export const GreenEditableSection = () => (
  <div className="green-editable-section">
    All fields below marked in <span className="green-word">green</span> are editable
  </div>
);
